import { render, staticRenderFns } from "./LocationModal.vue?vue&type=template&id=0673bf48"
import script from "./LocationModal.vue?vue&type=script&lang=js"
export * from "./LocationModal.vue?vue&type=script&lang=js"
import style0 from "./LocationModal.vue?vue&type=style&index=0&id=0673bf48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports